// Sign in by scanning (M49, D158): what the in-app scanner may follow.

const LINK_PATH = /^\/link\/([A-Za-z0-9_-]+)$/;

/**
 * The `/link/<code>` path of a scanned sign-in link, or null when the text
 * is anything else: another site, another page, or not a link at all. Only
 * this origin counts, so a scanned code can't send the phone elsewhere.
 */
export function signInLinkPath(text: string, origin: string): string | null {
  let url: URL;
  try {
    url = new URL(text.trim());
  } catch {
    return null;
  }
  if (url.origin !== origin) return null;
  return LINK_PATH.test(url.pathname) ? url.pathname : null;
}
